define([
	"dojo/_base/array",
	"dojo/_base/lang",
	"./_DropDownMenuPlugin",
	"./PluginFactory",
	"./util"
], function(array,lang,_DropDownMenuPlugin,PluginFactory,util) {

	return PluginFactory.declare([_DropDownMenuPlugin], {
		propertyKey: util.shapeProperties.strokeDash,
		materialIcon: "line_style",
		pluginName: "dash",
		title: "CanvasLineStyle",

		startup: function() {
			this.dropDown = this.createDropDownMenu([
				"svgIconDash0",
				"svgIconDash1",
				"svgIconDash2",
				"svgIconDash3",
				"svgIconDash4",
				"svgIconDash5",
				"svgIconDash6"
	        ]);

			// editor needs special logic to set and get dash style
			this.editor._attrGetters[this.cssStyle] = lang.hitch(this, this._getDashAttr);
			this.editor._attrSetters[this.cssStyle] = lang.hitch(this, this._setDashAttr);

			this.inherited(arguments);
		},

		getShapeAttrValue: function(shape) {
			return this._getDashAttr(shape);
		},

		encode: function(value) {
			return util.dashStyles[Number(value)];
		},

		decode: function(value) {
			return array.indexOf(util.dashStyles, value);
		},

		_getDashAttr: function(/*Shape*/shape) {
			// summary: get attribute based on shape
			var	i = array.indexOf(util.dashStyles, shape.getShapeStyle(this.cssStyle));
			return (i > 0) ? i : 0;
		},

		_setDashAttr: function(/*Shape*/shape, /*String*/value, /*Object?*/attrs) {
			// summary: set attribute based on menu item index
			if (!shape.getShapeLock()) {
				shape.setShapeStyle(this.cssStyle, util.dashStyles[Number(value)]);
			}
		}
	});
});